import React, { Component } from "react";
import { connect } from "react-redux";
import ProductUnitSelector from "../Components/ProductUnitSelector";
import { receive, loadError, hint } from "../Actions/Cart.action";
import { catchError } from "../Actions/Error.action";
import {
    add as addToCartService,
    remove as removeFromCartService,
} from "../Services/Cart.service";
import withReactiveStyleBuyButton from "./withReactiveStyleBuyButton";
import { update as updateOrderRowQuantity } from "../Actions/Cart.action";

class ProductUnitSelectorContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ProductUnitSelector
                {...this.props}
                getQuantity={(productsInCart, selectedArticleNumber) =>
                    getQuantity(productsInCart, selectedArticleNumber)
                }
                getOrderRowId={(productsInCart, selectedArticleNumber) =>
                    getOrderRowId(productsInCart, selectedArticleNumber)
                }
            />
        );
    }
}

const getQuantity = (productsInCart, selectedArticleNumber) => {
    const productInCart = productsInCart.find(
        (item) => selectedArticleNumber === item.articleNumber
    );
    if (productInCart) {
        return productInCart.quantity;
    } else {
        return 0;
    }
};

const getOrderRowId = (productsInCart, selectedArticleNumber) => {
    const productInCart = productsInCart.find(
        (item) => selectedArticleNumber === item.articleNumber
    );
    if (productInCart) {
        return productInCart.rowSystemId;
    }
};

const mapStateToProps = (state, ownProps) => {
    const orderRows = state.cart.orderRows;
    const articleNumbers = ownProps.unitOptions.map((a) => a.articleNumber);
    const productsInCart = orderRows.filter((item) =>
        articleNumbers.find((art) => art === item.articleNumber)
    );
    return {
        productsInCart: productsInCart,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onQuantityClick: (rowId, quantity, palletQuantity) =>
            dispatch(
                updateOrderRowQuantity(
                    rowId,
                    parseInt(quantity),
                    palletQuantity
                )
            ),
        onClick: (articleNumber, quantity, palletSize) => {
            addToCartService({ articleNumber, quantity, palletSize }).then(
                (cart) => dispatch(receive(cart))
            );
        },
        onRemove: (articleNumber) => {
            removeFromCartService({ articleNumber })
            .then((cart) => dispatch(receive(cart)))                                                  
                .catch((err) => {
                    console.error(`Could not change the unit type.\n${err}`);
                });
        },
        onSuccess: () => {
            dispatch(hint(true));
            setTimeout(() => {
                dispatch(hint(false));
            }, 2000);
        },
        onError: (ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
        },
    };
};

const onButtonClick = ({ articleNumber, quantityFieldId }) => {
    const quantity = quantityFieldId
        ? document.getElementById(quantityFieldId).value
        : 1;
    return addToCartService({ articleNumber, quantity });
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withReactiveStyleBuyButton(
        ProductUnitSelectorContainer,
        onButtonClick,
        "buy-button-container"
    )
);
